export default "__VITE_ASSET__CYZFTNvG__"